import React, { useState } from 'react';
// import { useState } from "react"
// import { Upload, Video, ChevronRight } from "lucide-react"
// import { Button } from 'antd';

// interface ModeProps {
//   onModeSelect: (mode: "UPLOADER" | "RECORDER") => void
//   onNext: (data: { mode: "UPLOADER" | "RECORDER"; fileType?: "video" | "dicom" }) => void
// }

// function ChooseRecordMode({ onModeSelect, onNext }: ModeProps) {
//   const [selectedMode, setSelectedMode] = useState<"UPLOADER" | "RECORDER" | null>(null)
//   const [fileType, setFileType] = useState<"video" | "dicom" | null>(null)

//   const handleModeSelect = (mode: "UPLOADER" | "RECORDER") => {
//     setSelectedMode(mode)
//     setFileType(null)
//     onModeSelect(mode)
//   }

//   const handleNext = () => {
//     if (selectedMode === "RECORDER") {
//       onNext({ mode: "RECORDER" })
//     } else if (selectedMode === "UPLOADER" && fileType) {
//       onNext({ mode: "UPLOADER", fileType })
//     }
//   }

//   return (
//     <div className="flex flex-col h-full">
//       <div className="mx-auto flex h-full w-full flex-col rounded-lg bg-white p-6 shadow-lg">
//         <div className="mb-4 flex h-16 justify-end">
//           {selectedMode && (
//             <Button
//               variant="outline"
//               className="text-blue-600"
//               onClick={handleNext}
//             >
//               Next
//             </Button>
//           )}
//         </div>
//         <div className="flex min-h-0 flex-1 gap-6 flex-col justify-center items-center">
//           <div className="flex justify-center items-center gap-8 w-full">
//             <div
//               className={`flex flex-col items-center gap-4 cursor-pointer transition-all duration-300 ${selectedMode === "UPLOADER" ? "scale-105" : ""
//                 }`}
//               onClick={() => handleModeSelect("UPLOADER")}
//             >
//               <div
//                 className={`w-64 h-64 border-2 border-blue-500 rounded-lg flex items-center justify-center bg-blue-50 ${selectedMode === "UPLOADER" ? "bg-blue-100" : ""
//                   }`}
//               >
//                 <div className="flex flex-col items-center gap-4 p-6 text-center">
//                   <Upload size={48} className="text-blue-600" />
//                   <h3 className="text-lg font-medium text-blue-700">Upload Files</h3>
//                   <p className="text-sm text-blue-600">Upload video or DICOM files from your device</p>
//                 </div>
//               </div>
//               <div className="btn btn-outline border-blue-500 text-blue-600 hover:bg-blue-500 hover:border-blue-600">
//                 UPLOADER mode
//               </div>
//             </div>

//             <div
//               className={`flex flex-col items-center gap-4 cursor-pointer transition-all duration-300 ${selectedMode === "RECORDER" ? "scale-105" : ""
//                 }`}
//               onClick={() => handleModeSelect("RECORDER")}
//             >
//               <div
//                 className={`w-64 h-64 border-2 border-blue-500 rounded-lg flex items-center justify-center bg-blue-50 ${selectedMode === "RECORDER" ? "bg-blue-100" : ""
//                   }`}
//               >
//                 <div className="flex flex-col items-center gap-4 p-6 text-center">
//                   <Video size={48} className="text-blue-600" />
//                   <h3 className="text-lg font-medium text-blue-700">Record Stream</h3>
//                   <p className="text-sm text-blue-600">Record video directly from your camera or device</p>
//                 </div>
//               </div>
//               <div className="btn btn-outline border-blue-500 text-blue-600 hover:bg-blue-500 hover:border-blue-600">
//                 recording mode
//               </div>
//             </div>
//           </div>

//           <div className=" flex justify-center">
//             <div className="w-full max-w-md p-6 border-2 border-blue-500 rounded-lg bg-white">
//               <h2 className="text-xl font-bold text-blue-700 mb-4 text-center">Select File Type</h2>

//               <div className="flex justify-center gap-4 mb-6">
//                 <div
//                   className={`p-4 border-2 rounded-lg cursor-pointer w-1/2 ${fileType === "video" ? "border-blue-500 bg-blue-100" : "border-gray-300 hover:border-blue-300"
//                     }`}
//                   onClick={() => setFileType("video")}
//                 >
//                   <div className="flex flex-col items-center gap-2">
//                     <Video className="w-8 h-8 text-blue-600" />
//                     <span className="font-medium">Video File</span>
//                   </div>
//                 </div>

//                 <div
//                   className={`p-4 border-2 rounded-lg cursor-pointer w-1/2 ${fileType === "dicom" ? "border-blue-500 bg-blue-100" : "border-gray-300 hover:border-blue-300"
//                     }`}
//                   onClick={() => setFileType("dicom")}
//                 >
//                   <div className="flex flex-col items-center gap-2">
//                     <svg
//                       className="w-8 h-8 text-blue-600"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M20 8.5V13.5M20 13.5V18.5M20 13.5H15M20 13.5H22"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                       <path
//                         d="M2 19.5V4.5C2 3.39543 2.89543 2.5 4 2.5H14.5C15.0523 2.5 15.5 2.94772 15.5 3.5V8.5C15.5 9.05228 15.9477 9.5 16.5 9.5H20C20.5523 9.5 21 9.94772 21 10.5V19.5C21 20.6046 20.1046 21.5 19 21.5H4C2.89543 21.5 2 20.6046 2 19.5Z"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                     <span className="font-medium">DICOM File</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )

// }

// export default ChooseRecordMode

// import { useState } from "react"
// import { Upload, Video, ChevronRight, FileDigit } from "lucide-react"
// import { Button, Divider, Typography } from "antd"

// const { Title, Text, Paragraph } = Typography

// interface ModeProps {
//   onModeSelect: (mode: "UPLOADER" | "RECORDER") => void
//   onNext: (data: { mode: "UPLOADER" | "RECORDER"; fileType?: "video" | "dicom" }) => void
// }

// export default function ChooseRecordMode({ onModeSelect, onNext }: ModeProps) {
//   const [selectedMode, setSelectedMode] = useState<"UPLOADER" | "RECORDER" | null>(null)
//   const [fileType, setFileType] = useState<"video" | "dicom" | null>(null)

//   const handleModeSelect = (mode: "UPLOADER" | "RECORDER") => {
//     setSelectedMode(mode)
//     setFileType(null)
//     onModeSelect(mode)
//   }

//   const handleNext = () => {
//     if (selectedMode === "RECORDER") {
//       onNext({ mode: "RECORDER" })
//     } else if (selectedMode === "UPLOADER" && fileType) {
//       onNext({ mode: "UPLOADER", fileType })
//     }
//   }

//   return (
//     // <div className=" py-8 px-4">
//       <div className="card bg-base-100 shadow-xl border-2 border-blue-100 h-full">
//         {/* Header */}
//         <div className="card-body p-0">
//           <div className="bg-gradient-to-r from-blue-50 to-white p-6 border-b border-blue-100">
//             <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//               <div>
//                 <Title level={3} className="text-blue-800 m-0">
//                   BlindSeep Imaging System
//                 </Title>
//                 <Text className="text-blue-600">Select how you would like to process medical images Recording</Text>
//               </div>
//               {selectedMode && (
//                 <Button
//                   type="primary"
//                   size="large"
//                   onClick={handleNext}
//                   disabled={selectedMode === "UPLOADER" && !fileType}
//                   className="bg-blue-600 hover:bg-blue-700 border-blue-700 flex items-center"
//                 >
//                   Next <ChevronRight className="ml-2 h-4 w-4" />
//                 </Button>
//               )}
//             </div>
//           </div>

//           <div className="p-6">
//             <div className="mb-8">
//               <div className="mb-4">
//                 <Title level={4} className="text-blue-800 flex items-center gap-2 m-0">
//                   <div className="badge badge-primary text-white">Step 1</div>
//                   Choose Input Method
//                 </Title>
//                 <Text className="text-blue-600">Select how you want to input the medical imaging data</Text>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div
//                   className={`card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
//                     selectedMode === "UPLOADER" ? "border-blue-600 bg-blue-50" : "border-blue-100 hover:border-blue-300"
//                   }`}
//                   onClick={() => handleModeSelect("UPLOADER")}
//                 >
//                   <div className="card-body p-6 flex flex-col items-center text-center">
//                     <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
//                       <Upload className="h-8 w-8 text-blue-600" />
//                     </div>
//                     <Title level={4} className="text-blue-800 m-0">
//                       Upload Files
//                     </Title>
//                     <Text className="text-blue-600">Import existing medical imaging files from your device</Text>
//                     <div className="mt-4">
//                       <div className="badge badge-outline badge-lg text-blue-500 font-medium">
//                         Supports video and DICOM formats
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div
//                   className={`card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
//                     selectedMode === "RECORDER" ? "border-blue-600 bg-blue-50" : "border-blue-100 hover:border-blue-300"
//                   }`}
//                   onClick={() => handleModeSelect("RECORDER")}
//                 >
//                   <div className="card-body p-6 flex flex-col items-center text-center">
//                     <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
//                       <Video className="h-8 w-8 text-blue-600" />
//                     </div>
//                     <Title level={4} className="text-blue-800 m-0">
//                       Record Stream
//                     </Title>
//                     <Text className="text-blue-600">Capture live video feed directly from medical equipment</Text>
//                     <div className="mt-4">
//                       <div className="badge badge-outline badge-lg text-blue-500 font-medium">
//                         Direct integration with compatible devices
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {selectedMode === "UPLOADER" && (
//               <div className="mt-8 animate-fadeIn">
//                 <Divider className="my-6" />
//                 <div className="mb-4">
//                   <Title level={4} className="text-blue-800 flex items-center gap-2 m-0">
//                     <div className="badge badge-primary text-white">Step 2</div>
//                     Select File Type
//                   </Title>
//                   <Text className="text-blue-600">Choose the type of medical imaging file you want to UPLOADER</Text>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div
//                     className={`card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
//                       fileType === "video" ? "border-blue-600 bg-blue-50" : "border-blue-100 hover:border-blue-300"
//                     }`}
//                     onClick={() => setFileType("video")}
//                   >
//                     <div className="card-body p-4 flex items-center">
//                       <div className="avatar placeholder mr-4">
//                         <div className="bg-blue-100 text-blue-600 rounded-full w-12">
//                           <Video className="h-6 w-6" />
//                         </div>
//                       </div>
//                       <div>
//                         <Title level={5} className="text-blue-800 m-0">
//                           Video File
//                         </Title>
//                         <Text className="text-blue-600">Standard video formats (MP4, AVI, MOV)</Text>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     className={`card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
//                       fileType === "dicom" ? "border-blue-600 bg-blue-50" : "border-blue-100 hover:border-blue-300"
//                     }`}
//                     onClick={() => setFileType("dicom")}
//                   >
//                     <div className="card-body p-4 flex items-center">
//                       <div className="avatar placeholder mr-4">
//                         <div className="bg-blue-100 text-blue-600 rounded-full w-12">
//                           <FileDigit className="h-6 w-6" />
//                         </div>
//                       </div>
//                       <div>
//                         <Title level={5} className="text-blue-800 m-0">
//                           DICOM File
//                         </Title>
//                         <Text className="text-blue-600">Medical imaging standard format (DCM)</Text>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     // </div>
//   )
// }

import { Upload, Video, ChevronRight, FileDigit } from 'lucide-react';
import { Button, Divider, Typography } from 'antd';

const { Title, Text } = Typography;

interface ModeProps {
  onModeSelect: (mode: 'UPLOADER' | 'RECORDER') => void;
  onNext: (data: {
    mode: 'UPLOADER' | 'RECORDER';
    fileType?: 'video' | 'dicom';
  }) => void;
}

export default function ChooseRecordMode({ onModeSelect, onNext }: ModeProps) {
  const [selectedMode, setSelectedMode] = useState<
    'UPLOADER' | 'RECORDER' | null
  >(null);
  const [fileType, setFileType] = useState<'video' | 'dicom' | null>(null);

  const handleModeSelect = (mode: 'UPLOADER' | 'RECORDER') => {
    setSelectedMode(mode);
    setFileType(null);
    onModeSelect(mode);
  };

  const handleNext = () => {
    if (selectedMode === 'RECORDER') {
      onNext({ mode: 'RECORDER' });
    } else if (selectedMode === 'UPLOADER' && fileType) {
      onNext({ mode: 'UPLOADER', fileType });
    }
  };

  return (
    <div
      className="
       w-full h-full flex flex-col
       dui-bg-base-100 border-2 border-blue-100
    "
    >
      <div className="dui-card h-full flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-50 to-white p-4 sm:p-6 border-b border-blue-100 flex h-1/4">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full">
            <div>
              <Title
                level={3}
                className="text-blue-800 m-0 text-xl sm:text-2xl md:text-3xl"
              >
                Medical BlindSweep Imaging System "fix dev branch regression (code - cicd - infra - runner - gcp)"
              </Title>
              <Text className="text-blue-600 text-sm sm:text-base">
                Select how you would like to process medical images
              </Text>
            </div>
            {selectedMode && (
              <Button
                type="primary"
                size="large"
                onClick={handleNext}
                disabled={selectedMode === 'UPLOADER' && !fileType}
                className="bg-blue-600 hover:bg-blue-700 border-blue-700 flex items-center text-sm sm:text-base"
              >
                Continue <ChevronRight className="ml-2 h-4 w-4" />
              </Button>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 flex-1">
          {/* Step 1 */}
          <div className="mb-6 sm:mb-8">
            <div className="mb-4">
              <Title
                level={4}
                className="text-blue-800 flex items-center gap-2 m-0 text-lg sm:text-xl"
              >
                <div className="dui-badge dui-badge-primary text-white text-xs sm:text-sm">
                  Step 1:{' '}
                </div>
                Choose Input Method
              </Title>
              <Text className="text-blue-600 text-sm sm:text-base">
                Select how you want to input the medical imaging data
              </Text>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {/* Upload Option */}
              <div
                className={`dui-card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
                  selectedMode === 'UPLOADER'
                    ? 'border-blue-600 dui-bg-blue-50'
                    : 'border-blue-100 hover:border-blue-300'
                }`}
                onClick={() => handleModeSelect('UPLOADER')}
              >
                <div className="dui-card-body p-4 sm:p-6 flex flex-col items-center text-center">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-blue-100 flex items-center justify-center mb-3 sm:mb-4">
                    <Upload className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600" />
                  </div>
                  <Title
                    level={4}
                    className="text-blue-800 m-0 text-lg sm:text-xl"
                  >
                    Upload Files
                  </Title>
                  <Text className="text-blue-600 text-sm sm:text-base">
                    Import existing medical imaging files from your device
                  </Text>
                  <div className="mt-3 sm:mt-4">
                    <div className="dui-badge dui-badge-outline dui-badge-lg text-blue-500 font-medium text-xs sm:text-sm">
                      Supports video and DICOM formats
                    </div>
                  </div>
                </div>
              </div>

              {/* Record Option */}
              <div
                className={`dui-card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
                  selectedMode === 'RECORDER'
                    ? 'border-blue-600 dui-bg-blue-50'
                    : 'border-blue-100 hover:border-blue-300'
                }`}
                onClick={() => handleModeSelect('RECORDER')}
              >
                <div className="dui-card-body p-4 sm:p-6 flex flex-col items-center text-center">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-blue-100 flex items-center justify-center mb-3 sm:mb-4">
                    <Video className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600" />
                  </div>
                  <Title
                    level={4}
                    className="text-blue-800 m-0 text-lg sm:text-xl"
                  >
                    Record Stream
                  </Title>
                  <Text className="text-blue-600 text-sm sm:text-base">
                    Capture live video feed directly from medical equipment
                  </Text>
                  <div className="mt-3 sm:mt-4">
                    <div className="dui-badge dui-badge-outline dui-badge-lg text-blue-500 font-medium text-xs sm:text-sm">
                      Direct integration with compatible devices
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Step 2 - File Type Selection */}
          {selectedMode === 'UPLOADER' && (
            <div className="mt-6 sm:mt-8 animate-fadeIn">
              <div className="mb-4">
                <Title
                  level={4}
                  className="text-blue-800 flex items-center gap-2 m-0 text-lg sm:text-xl"
                >
                  <div className="dui-badge dui-badge-primary text-white text-xs sm:text-sm">
                    Step 2:{' '}
                  </div>
                  Select File Type
                </Title>
                <Text className="text-blue-600 text-sm sm:text-base">
                  Choose the type of medical imaging file you want to UPLOADER
                </Text>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                {/* Video File Option */}
                <div
                  className={`dui-card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
                    fileType === 'video'
                      ? 'border-blue-600 dui-bg-blue-50'
                      : 'border-blue-100 hover:border-blue-300'
                  }`}
                  onClick={() => setFileType('video')}
                >
                  <div className="dui-card-body p-3 sm:p-4 flex items-center">
                    <div className="dui-avatar dui-placeholder mr-3 sm:mr-4">
                      <div className="bg-blue-100 text-blue-600 rounded-full w-10 sm:w-12">
                        <Video className="h-5 w-5 sm:h-6 sm:w-6" />
                      </div>
                    </div>
                    <div>
                      <Title
                        level={5}
                        className="text-blue-800 m-0 text-base sm:text-lg"
                      >
                        Video File
                      </Title>
                      <Text className="text-blue-600 text-xs sm:text-sm">
                        Standard video formats (MP4, AVI, MOV)
                      </Text>
                    </div>
                  </div>
                </div>

                {/* DICOM File Option */}
                <div
                  className={`dui-card cursor-pointer hover:shadow-md transition-all duration-200 border-2 ${
                    fileType === 'dicom'
                      ? 'border-blue-600 dui-bg-blue-50'
                      : 'border-blue-100 hover:border-blue-300'
                  }`}
                  onClick={() => setFileType('dicom')}
                >
                  <div className="dui-card-body p-3 sm:p-4 flex items-center">
                    <div className="dui-avatar dui-placeholder mr-3 sm:mr-4">
                      <div className="bg-blue-100 text-blue-600 rounded-full w-10 sm:w-12">
                        <FileDigit className="h-5 w-5 sm:h-6 sm:w-6" />
                      </div>
                    </div>
                    <div>
                      <Title
                        level={5}
                        className="text-blue-800 m-0 text-base sm:text-lg"
                      >
                        DICOM File
                      </Title>
                      <Text className="text-blue-600 text-xs sm:text-sm">
                        Medical imaging standard format (DCM)
                      </Text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
